// extracted by mini-css-extract-plugin
export var block = "styles-module--block--afa03";
export var blockContent = "styles-module--blockContent--bad27";
export var blockImage = "styles-module--blockImage--b219d";
export var blocks = "styles-module--blocks--c09a6";
export var container = "styles-module--container--2e509";
export var cta = "styles-module--cta--7438a";
export var reverse = "styles-module--reverse--d3bb7";
export var textContent = "styles-module--textContent--baf56";
export var title = "styles-module--title--8dcd3";
export var visible = "styles-module--visible--bcf6e";